import { CAT_BODY_TYPE } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";

import { createEnumTranslations } from "./createEnumTranslations";

const bodyTypes = Object.keys(CAT_BODY_TYPE) as (keyof typeof CAT_BODY_TYPE)[];

export const useCatBodyType = () => {
  const tBodyTypes = useTranslations("Cats.BodyTypes");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: bodyTypes,
    translate: (bodyType) => {
      if (bodyType === "UNKNOWN") {
        return unknown;
      }

      return tBodyTypes(snakeCaseToCamelCase(bodyType));
    },
    fallback: unknown,
  });
};
